// extracted by mini-css-extract-plugin
export var closeButton = "AppToaster-module--closeButton--cb6ac";
export var toast = "AppToaster-module--toast--cb91b";
export var toastContent = "AppToaster-module--toastContent--6b60c";